import type { LngLat } from "@bbj-types/address";
import type { ISupportCourse } from "@bbj-types/supportCourse";
import type { IUser } from "@bbj-types/user";
import type { Override } from "@bbj-types/utils";
import type { IWorkshop } from "@bbj-types/workshop";
import type { SortBy } from "@root/SupportCourse/dashboard/components/table/supportCourseSortBy/constants";
import { useCallback } from "react";
import { supportCourseAxios } from "./axios";

export type TSupportCourseSortBy = SortBy;

export interface IGetSupportCourseDashboardQuery {
  multiSearch?: string;
  beginDate?: {
    startDate?: Date | null;
    endDate?: Date | null;
  };
  endDate?: {
    startDate?: Date | null;
    endDate?: Date | null;
  };
  "internships.startDate"?: {
    startDate?: Date | null;
    endDate?: Date | null;
  };
  "internships.endDate"?: {
    startDate?: Date | null;
    endDate?: Date | null;
  };
  address?: {
    loc: LngLat;
    distance: number;
  };
  isDone?: boolean;
  isCancelled?: boolean;
  limit: number;
  skip: number;
  sortBy: TSupportCourseSortBy;
}

export interface IGetSupportCourseDashboard {
  data: Override<
    ISupportCourse,
    {
      owner: Pick<IUser, "_id" | "firstName" | "lastName">;
      sessions: Pick<IWorkshop, "_id" | "isDone">[];
      participants: number;
    }
  >[];
  limit: number;
  skip: number;
  total: number;
  count: number;
  sortBy: TSupportCourseSortBy;
}

export const useGetSupportCoursesDashboard = () => {
  const [state, execute, cancel] = supportCourseAxios<IGetSupportCourseDashboard, void, unknown>(
    {
      url: "/supportCourses",
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );
  const callback = useCallback(
    (filters: IGetSupportCourseDashboardQuery) => {
      return execute({
        params: filters,
      });
    },
    [execute]
  );
  return [state, callback, cancel] as const;
};
